import React, { PureComponent } from 'react'
import { Table } from 'react-bootstrap'
import { bindActionCreators } from 'redux'
import { closeSrcLightbox, openSrcLightbox } from '../../actions/src_lightbox'
import { connect } from 'react-redux'
import Lightbox from 'react-image-lightbox'
import { detectDocumentTypeInUrl } from '../../utils/filters'
import { DOCUMENT_TYPE_IMAGE, DOCUMENT_TYPE_PDF } from '../../config'
import { formatTimeString } from '../../utils/formatters'
import PdfModalDialog from '../tx_details_components/verification_documents/pdf_modal_dialog'
import { openIdentityPdfModalDialog } from '../../actions/pdf_modal_dialog'
import { getPdfFileName, savePdf } from '../../utils/pdf'
import { fetchBusinessDocumentTypes } from '../../actions/business_document_types'

class BusinessDocuments extends PureComponent {
  componentDidMount() {
    if (this.props.businessDocumentTypes.length === 0) {
      this.props.fetchBusinessDocumentTypes()
    }
  }

  render() {
    const {
      openSrcLightbox,
      closeSrcLightbox,
      isSrcLightboxOpen,
      documents,
      singleImgSrc,
      openIdentityPdfModalDialog,
      businessDocumentTypes,
    } = this.props

    const normalizedDocs = documents.map((doc) => {
      const type = detectDocumentTypeInUrl(doc.document)
      return Object.assign({ doctype: type }, ...Object.keys(doc).map((k) => ({ [k]: doc[k] })))
    })

    const isPdf =
      normalizedDocs.reduce((acc, currentValue) => {
        if (currentValue.doctype === DOCUMENT_TYPE_PDF) {
          acc++
        }
        return acc
      }, 0) > 0

    const tableHead = isPdf ? (
      <tr>
        <th>Id</th>
        <th>Type</th>
        <th>Document Type</th>
        <th>View</th>
        <th>Download</th>
        <th>Created</th>
        <th>Updated</th>
      </tr>
    ) : (
      <tr>
        <th>Id</th>
        <th>Type</th>
        <th>Document</th>
        <th>Created</th>
        <th>Updated</th>
      </tr>
    )

    return (
      <div className='ibox float-e-margins shadow animated fadeIn'>
        <div className='ibox-title round-corner-box-top'>
          <h5>Business Documents</h5>
        </div>
        <div className='ibox-content round-corner-box-bottom'>
          {normalizedDocs && normalizedDocs.length ? (
            <Table striped bordered hover>
              <thead>{tableHead}</thead>
              <tbody>
                {normalizedDocs.map((entry, i) => {
                  let downloadDoc = null
                  let iconClass = 'fa fa-file-o fa-2x cursor-pointer'
                  let onclick = () => window.open(entry.document, '_blank')
                  if (entry.doctype === DOCUMENT_TYPE_IMAGE) {
                    iconClass = 'fa fa-file-image-o fa-2x cursor-pointer'
                    onclick = () => openSrcLightbox(entry.document)
                  }
                  if (entry.doctype === DOCUMENT_TYPE_PDF) {
                    iconClass = 'fa fa-file-pdf-o fa-2x cursor-pointer'
                    onclick = () => openIdentityPdfModalDialog(entry)
                    downloadDoc = (
                      <td>
                        <div
                          onClick={() => savePdf(entry.document, getPdfFileName(entry.document))}
                          className='cursor-pointer'
                        >
                          <i className='fa fa-download fa-2x' title='Download Document' />
                        </div>
                      </td>
                    )
                  }
                  let type = businessDocumentTypes.find((type) => entry.document_type === type.id)
                  return (
                    <tr key={i}>
                      <td>{entry.id}</td>
                      <td>{entry.doctype}</td>
                      <td>{type && <span>{type.display_name}</span>}</td>
                      <td>
                        <i className={iconClass} onClick={onclick} title='View Document' />
                      </td>
                      {downloadDoc}
                      <td>{formatTimeString(entry.created)}</td>
                      <td>{formatTimeString(entry.updated)}</td>
                    </tr>
                  )
                })}
              </tbody>
            </Table>
          ) : (
            <span>{'N/A'}</span>
          )}
          {isSrcLightboxOpen && <Lightbox mainSrc={singleImgSrc} onCloseRequest={() => closeSrcLightbox()} />}
          <PdfModalDialog />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  isSrcLightboxOpen: state.srcLightbox.isSrcLightboxOpen,
  singleImgSrc: state.srcLightbox.src,
  isModalDialogOpen: state.identityPdfModalDialog.isModalDialogOpen,
  businessDocumentTypes: state.businessDocumentTypes.types,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openSrcLightbox,
      closeSrcLightbox,
      openIdentityPdfModalDialog,
      fetchBusinessDocumentTypes,
    },
    dispatch
  )

export default connect(mapStateToProps, mapDispatchToProps)(BusinessDocuments)
